module.exports = __webpack_public_path__ + "static/media/list.d1802e63.png";